import React from 'react'

export default function Dvider({ color, m }) {
    return (
        <div style={{ height: "1px", width: "100%", backgroundColor:color,margin: m}}>

        </div>
    )
}
